import { ApiSchemas } from '..'
import { client } from '../client'
import { wrapEndpoint } from '../wrap'

export type Disease = ApiSchemas['DiseasePresenter']

export default {
  async list(options?: ApiSchemas['ListDiseaseDto']) {
    return wrapEndpoint(() =>
      client.GET('/disease', {
        params: {
          query: options,
        },
      }),
    )
  },
  async get(id: number) {
    return wrapEndpoint(() =>
      client.GET('/disease/{id}', {
        params: {
          path: { id },
        },
      }),
    )
  },
}
